import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from './context/AuthContext';
import Login from './components/auth/Login';
import Users from './pages/Users';
import Permissions from './pages/Permissions';
import Unauthorized from './pages/Unauthorized';
import Home from './pages/Home';
import Tutorials from './pages/Tutorials';
import Layout from './pages/Layout';
import './index.css';
import Appointments from './pages/Appointments';
import Notifications from './pages/Notifications';
import Links from './pages/Links';
import Questions from './pages/Questions';
import LandingPage from './pages/LandingPage';
import TeamPage from './pages/TeamPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
// --- Chat Admin Pages ---
import InterviewBuilder from './pages/InterviewBuilder';
import Submissions from './pages/Submissions';
import TestChat from './pages/TestChat';
import PatientGroups from './pages/PatientGroups';
import RagDocs from './pages/RagDocs';

const App = () => {
    const { isAuthenticated, userRole } = useContext(AuthContext);

    const allowedRoles = ["Director", "Navegador", "Lector"];

    const ProtectedRoute = ({ children }) => {
        if (!isAuthenticated) {
            return <Navigate to="/login" />;
        }
        return children;
    };

    const RoleBasedLayout = ({ children }) => {
        if (!allowedRoles.includes(userRole)) {
            return <Navigate to="/unauthorized" />;
        }
        return <Layout>{children}</Layout>;
    };

    const ChatIALayout = ({ children }) => {
        const adminRoles = ["Director", "Navegador"];
        if (!adminRoles.includes(userRole)) {
            return <Navigate to="/unauthorized" />;
        }
        return <Layout>{children}</Layout>;
    };


    return (
        <BrowserRouter>
            <Routes>
                {/* --- Rutas Públicas --- */}
                <Route
                    path="/login"
                    element={!isAuthenticated ? <Login /> : <Navigate to="/" />}
                />
                <Route path="/landing" element={<LandingPage />} />
                <Route path="/TeamPage" element={<TeamPage />} />
                <Route path="/unauthorized" element={<Layout><Unauthorized /></Layout>} />
                <Route path="/aviso-privacidad" element={<PrivacyPolicyPage />} />

                {/* --- Ruta Raíz Condicional --- */}
                <Route
                    path="/"
                    element={
                        isAuthenticated
                            ? <ProtectedRoute><RoleBasedLayout><Home /></RoleBasedLayout></ProtectedRoute>
                            : <LandingPage />
                    }
                />

                {/* --- Rutas Protegidas (Requieren Login y Rol) --- */}
                <Route path="/users" element={<ProtectedRoute><RoleBasedLayout><Users /></RoleBasedLayout></ProtectedRoute>} />
                <Route path="/tutorials" element={<ProtectedRoute><RoleBasedLayout><Tutorials /></RoleBasedLayout></ProtectedRoute>} />
                <Route path="/permissions" element={<ProtectedRoute><RoleBasedLayout><Permissions /></RoleBasedLayout></ProtectedRoute>} />
                <Route path="/appointments" element={<ProtectedRoute><RoleBasedLayout><Appointments /></RoleBasedLayout></ProtectedRoute>} />
                <Route path="/notifications" element={<ProtectedRoute><RoleBasedLayout><Notifications /></RoleBasedLayout></ProtectedRoute>} />
                <Route path="/links" element={<ProtectedRoute><RoleBasedLayout><Links /></RoleBasedLayout></ProtectedRoute>} />
                <Route path="/questions" element={<ProtectedRoute><RoleBasedLayout><Questions /></RoleBasedLayout></ProtectedRoute>} />

                {/* --- Chat Admin Pages --- */}
                <Route path="/interviews" element={<ProtectedRoute><ChatIALayout><InterviewBuilder /></ChatIALayout></ProtectedRoute>} />
                <Route path="/submissions" element={<ProtectedRoute><ChatIALayout><Submissions /></ChatIALayout></ProtectedRoute>} />
                <Route path="/test-chat" element={<ProtectedRoute><ChatIALayout><TestChat /></ChatIALayout></ProtectedRoute>} />
                <Route path="/groups" element={<ProtectedRoute><ChatIALayout><PatientGroups /></ChatIALayout></ProtectedRoute>} />
                <Route path="/rag-docs" element={<ProtectedRoute><ChatIALayout><RagDocs /></ChatIALayout></ProtectedRoute>} />

            </Routes>
        </BrowserRouter>
    );
};

export default App;
